export default __webpack_public_path__ + "static/media/fuji@2x.c3f2aa98.png";